import React from 'react';
import { translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import { T, cardStyle } from './chainSettingsV2Styles';

class ChainSettingsMenuV2 extends React.Component {
  render() {
    const { t, location, chain, userRole } = this.props;
    const currentPath = location.pathname;
    const isAdmin = userRole === 'admin';
    const isAdminOrManager = userRole === 'admin' || userRole === 'manager';

    const menuItems = [
      { path: '/chain-settings/info', label: t('menuChainInfo'), icon: 'pi pi-building' },
    ];
    if (isAdmin) {
      menuItems.push({ path: '/chain-settings/permissions', label: t('menuChainPermissions'), icon: 'pi pi-users' });
      menuItems.push({ path: '/chain-settings/memberships', label: t('menuChainMemberships'), icon: 'pi pi-wrench' });
    }
    if (isAdminOrManager) {
      menuItems.push({ path: '/chain-settings/care-services', label: t('menuChainCareServices'), icon: 'pi pi-heart' });
      menuItems.push({ path: '/chain-settings/customer-vehicles', label: t('menuCustomerVehicles'), icon: 'pi pi-car' });
    }
    if (chain && chain.use_consolidated_invoicing && isAdminOrManager) {
      menuItems.push({ path: '/chain-settings/invoice', label: t('menuInvoiceSettings'), icon: 'pi pi-money-bill' });
    }
    if (chain && chain.use_consolidated_invoicing && isAdmin) {
      menuItems.push({ path: '/chain-settings/netvisor', label: t('menuNetvisorConnection'), icon: 'pi pi-cloud' });
    }
    if (isAdminOrManager) {
      menuItems.push({ path: '/chain-settings/audit-log', label: t('menuAuditLog'), icon: 'pi pi-list' });
    }

    return (
      <CBMediaQuery>
        {screenSize => {
          const isActive = (itemPath) => (
            currentPath === itemPath
            || ((currentPath === '/chain-settings/' || currentPath === '/chain-settings') && itemPath === '/chain-settings/info')
          );

          return (
            <div style={getStyle(screenSize, styles, 'menuCard')}>
              <nav style={getStyle(screenSize, styles, 'nav')}>
                {menuItems.map(item => (
                  <Link
                    key={item.path}
                    to={item.path}
                    style={{
                      ...getStyle(screenSize, styles, 'menuItem'),
                      ...(isActive(item.path) ? getStyle(screenSize, styles, 'menuItemActive') : {}),
                    }}
                  >
                    <i
                      className={item.icon}
                      style={{
                        ...styles.default.menuIcon,
                        ...(isActive(item.path) ? styles.default.menuIconActive : {}),
                      }}
                    />
                    <span>{item.label}</span>
                    {isActive(item.path) && screenSize === 'large' && (
                      <i className="pi pi-chevron-right" style={styles.default.chevron} />
                    )}
                  </Link>
                ))}
                <div style={getStyle(screenSize, styles, 'separator')} />
                <a
                  href="/accounts/logout"
                  style={getStyle(screenSize, styles, 'menuItem')}
                >
                  <i
                    className="pi pi-sign-out"
                    style={styles.default.menuIcon}
                  />
                  <span>{t('menuLogout')}</span>
                </a>
              </nav>
            </div>
          );
        }}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    menuCard: {
      ...cardStyle,
      padding: '8px 0',
    },
    nav: {
      display: 'flex',
      flexDirection: 'column',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      color: T.textSecondary,
      padding: '12px 20px',
      textDecoration: 'none',
      fontSize: 14,
      borderLeft: '3px solid transparent',
      transition: 'all 0.15s ease',
      position: 'relative',
    },
    menuItemActive: {
      color: '#fff',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderLeft: '3px solid #fff',
    },
    menuIcon: {
      fontSize: 16,
      width: 20,
      textAlign: 'center',
      color: T.textSecondary,
    },
    menuIconActive: {
      color: '#fff',
    },
    chevron: {
      fontSize: 11,
      marginLeft: 'auto',
      color: '#fff',
      opacity: 0.6,
    },
    separator: {
      height: 1,
      backgroundColor: T.border,
      margin: '4px 16px',
    },
  },
  medium: {
    menuCard: {
      ...cardStyle,
      padding: '4px 8px',
      borderRadius: 8,
    },
    nav: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    menuItem: {
      padding: '8px 14px',
      borderLeft: 'none',
      borderBottom: '2px solid transparent',
      fontSize: 13,
      gap: 8,
    },
    menuItemActive: {
      borderLeft: 'none',
      borderBottom: '2px solid #fff',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#fff',
    },
    separator: {
      width: 1,
      height: 20,
      backgroundColor: T.border,
      margin: '4px 0',
      alignSelf: 'center',
    },
  },
};

export default withRouter(translate('ChainSettingsView')(ChainSettingsMenuV2));
